import { Record } from 'immutable';

const LookupAddressRecord = Record({
  line1: null,
  line2: null,
  line3: null,
  countryCode: null,
  city: null,
  state: null,
  postalCode: null
});

export class LookupAddress extends LookupAddressRecord {
  line1: string;
  line2: string;
  line3: string;
  countryCode: string;
  city: string;
  state: string;
  postalCode: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/lookup-address.ts